import SpinnerLoading from '@components/V3/loadingIndicators/Spinner'
import classnames from '@helpers/misc/classnames'
import useIsDarkMode from '@hooks/useIsDarkMode'
import dayjs from 'dayjs'

import HR from '../../HR'
import {ReservationLabel} from '../../Label'
import {useCreateReservationContext} from '../../ReservationContext'

export default function SelectSlot() {
  const {setSectorId, setDate, date, sectorId, timezone, availabilityOptions} =
    useCreateReservationContext()
  const {options, loading} = availabilityOptions
  const isDarkMode = useIsDarkMode()

  return (
    <div className="space-y-3">
      <HR className="mt-2">Selecciona el horario</HR>
      {loading && (
        <div className="flex justify-center py-10">
          <SpinnerLoading />
        </div>
      )}
      {options
        .filter(option => !option.sector.disabledForReservations)
        .map(option => (
          <div key={option.sector._id}>
            <ReservationLabel>{option.sector.name}</ReservationLabel>
            <div className="-mx-1">
              {option.dates.length === 0 && (
                <div
                  className={classnames({
                    'text-sm text-gray-500 m-1': !isDarkMode,
                    'text-sm text-gray-400 m-1': isDarkMode,
                  })}
                >
                  No hay horarios disponibles
                </div>
              )}
              <div className="grid grid-cols-5 space-x-2 px-1">
                {option.dates.map((dateOption, index) => {
                  const selected =
                    dayjs(dateOption.date).tz(timezone).isSame(dayjs(date)) &&
                    option.sector._id === sectorId
                  return (
                    <div
                      key={index}
                      className={classnames(
                        'rounded-lg flex items-center justify-center h-10 cursor-pointer',
                        'border',
                        {
                          'hover:bg-gray-200': !isDarkMode,
                          'hover:bg-gray-700': isDarkMode,

                          'text-gray-600 border-gray-300': !selected && !isDarkMode,
                          'text-gray-400 border-gray-700': !selected && isDarkMode,

                          'font-semibold text-gray-800 border-gray-800': selected && !isDarkMode,
                          'font-semibold text-gray-200 border-gray-200': selected && isDarkMode,
                        },
                      )}
                      onClick={() => {
                        setSectorId(option.sector._id)
                        setDate(dateOption.date)
                      }}
                    >
                      {dayjs(dateOption.date).tz(timezone).format('HH:mm')}
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        ))}
    </div>
  )
}
